var _jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/components/ByNeedSubMenu.js",
  _this = this;
import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid, Row } from '@sm/wds-react';
import { T } from '@sm/intl';
import NavSubmenuCopy from '../../../copy/NavSubmenuCopy';
export var ByNeedSubMenu = function ByNeedSubMenu(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Grid, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "cardTitle",
    color: "dark",
    className: "sm-nav-submenu__by-need-title",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: NavSubmenuCopy.BY_NEED,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(Row, {
    className: "submenu-lo--row",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 7
    }
  }, children));
};
export default ByNeedSubMenu;
ByNeedSubMenu.propTypes = {
  children: PropTypes.node.isRequired
};
//# sourceMappingURL=ByNeedSubMenu.js.map